const postsReducer = (state = {}, action) => {
  //console.log(state, action);

  switch (action.type) {
    case "SET_POSTS":
      // return {
      //     ...state.posts,
      //     [action.posts.catId]: action.posts.data
      //   }
      
      //posts: [...state.arr, action.posts]
      
      return action.posts;
    case "CLEAR_POSTS":
      return null;
      // return {
      //   ...state.posts,
      //   [action.posts.catId]: null
      // }
  default:
      return state;
  }
};

export default postsReducer;
